export default __webpack_public_path__ + "assets/images/5418db9e7397311dcaa9ec98ae4a317f.jpg";